export default __webpack_public_path__ + "static/media/check.2a5f41e5.svg";